import roMessages from "../locales/ro_RO";

const roLang = {
  messages: {
    ...roMessages,
  },
  locale: "ro-RO",
};
export default roLang;
